__turbopack_context__.v({
  "cardWrapper": "cardHeader-module-scss-module__Huxjaq__cardWrapper",
  "color": "cardHeader-module-scss-module__Huxjaq__color",
  "comboSubtitle": "cardHeader-module-scss-module__Huxjaq__comboSubtitle",
  "comboTitle": "cardHeader-module-scss-module__Huxjaq__comboTitle",
  "comboTitleWrapper": "cardHeader-module-scss-module__Huxjaq__comboTitleWrapper",
  "header": "cardHeader-module-scss-module__Huxjaq__header",
  "headingTitle": "cardHeader-module-scss-module__Huxjaq__headingTitle",
  "mask": "cardHeader-module-scss-module__Huxjaq__mask",
});
